export default {
  MPI: '708d9d3a-fc7c-4b6b-b911-e39f160045b5',
  DaffId: '10d0a926-ef14-42d2-a484-c7dd7fa53822',
  DaffArhopalusId: 'a1fbd66f-e4dd-4b99-8f35-04ab19908cd6'
};
